import { render, staticRenderFns } from "./RankingTab.vue?vue&type=template&id=b7057330&scoped=true"
import script from "./RankingTab.vue?vue&type=script&lang=js"
export * from "./RankingTab.vue?vue&type=script&lang=js"
import style0 from "./RankingTab.vue?vue&type=style&index=0&id=b7057330&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7057330",
  null
  
)

export default component.exports